import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=ce0ba5ae&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=ts"
export * from "./CopyButton.vue?vue&type=script&lang=ts"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=ce0ba5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0ba5ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VHover,VIcon,VTooltip})
